import { easeCurves } from "../eases/eases";
import { css } from 'styled-components';
import { theme } from "../../theme";
/**
 * all the props accepted by the drag transition.
 */
// defaults

var OPACITY_DEFAULT = 1;
var OPACITY_ACTIVE = 0.5;
var SCALE_DEFAULT = 1;
var SCALE_ACTIVE = 0.9;
var BORDER_RADIUS_DEFAULT = '0px';
var BORDER_RADIUS_ACTIVE = theme.radii[8];
var BACKGROUND_DEFAULT = '#5B53FF';
var BACKGROUND_ACTIVE = '#48A2FF';
var DURATION_ACTIVE = 750;
var DURATION_DEFAULT = 250;
/**
 * A simple Reveal transition can toggle if "active" or not as well as selecting a background color.
 * Available css variables for consumption by children:
 * ```
 * --vapor-drag-transition-ease
 * --vapor-drag-transition-duration
 *```
 *
 * Optional configurations:
 * @param {number} [props.opacityActive=0.5]
 * @param {number} [props.opacityDefault=1]
 * @param {string} [props.borderRadiusActive='12px']
 * @param {string} [props.borderRadiusDefault='0px']
 * @param {number} [props.scaleActive=0.9]
 * @param {number} [props.scaleDefault=1]
 * @param {number} [props.durationActive=750]
 * @param {number} [props.durationDefault=250]
 * @param {string} [props.backgroundActive='#48A2FF']
 * @param {string} [props.backgroundDefault='#5B53FF']
 *
 * @example
 * const DraggableComponent = styled.div`
 *  ${transitionDrag()}
 * `;
 *
 * @param {boolean} isActive toggles transition between the two states.
 *
 * @example
 * ```jsx
 * <motion.div drag>
 *  <DraggableComponent isActive={isDragging}>
 *    {...children}
 *  </DraggableComponent>
 * </motion.div>
 *```
 */

export var transitionDrag = function transitionDrag() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _props$opacityActive = props.opacityActive,
      opacityActive = _props$opacityActive === void 0 ? OPACITY_ACTIVE : _props$opacityActive,
      _props$opacityDefault = props.opacityDefault,
      opacityDefault = _props$opacityDefault === void 0 ? OPACITY_DEFAULT : _props$opacityDefault,
      _props$borderRadiusAc = props.borderRadiusActive,
      borderRadiusActive = _props$borderRadiusAc === void 0 ? BORDER_RADIUS_ACTIVE : _props$borderRadiusAc,
      _props$borderRadiusDe = props.borderRadiusDefault,
      borderRadiusDefault = _props$borderRadiusDe === void 0 ? BORDER_RADIUS_DEFAULT : _props$borderRadiusDe,
      _props$scaleActive = props.scaleActive,
      scaleActive = _props$scaleActive === void 0 ? SCALE_ACTIVE : _props$scaleActive,
      _props$scaleDefault = props.scaleDefault,
      scaleDefault = _props$scaleDefault === void 0 ? SCALE_DEFAULT : _props$scaleDefault,
      _props$backgroundActi = props.backgroundActive,
      backgroundActive = _props$backgroundActi === void 0 ? BACKGROUND_ACTIVE : _props$backgroundActi,
      _props$backgroundDefa = props.backgroundDefault,
      backgroundDefault = _props$backgroundDefa === void 0 ? BACKGROUND_DEFAULT : _props$backgroundDefa,
      _props$durationActive = props.durationActive,
      durationActive = _props$durationActive === void 0 ? DURATION_ACTIVE : _props$durationActive,
      _props$durationDefaul = props.durationDefault,
      durationDefault = _props$durationDefaul === void 0 ? DURATION_DEFAULT : _props$durationDefaul;
  return css(["--vapor-drag-transition-ease:", ";--vapor-drag-transition-duration:", ";background-color:", ";border-radius:", ";transform:scale(", ");transition-property:border-radius,transform,background-color;transition-timing-function:var(--vapor-drag-transition-ease);transition-duration:var(--vapor-drag-transition-duration);& > *{opacity:", ";transition-property:opacity;transition-timing-function:var(--vapor-drag-transition-ease);transition-duration:var(--vapor-drag-transition-duration);}"], function (p) {
    return p.isActive ? easeCurves.easeOutQuint : easeCurves.decelerate;
  }, function (p) {
    return p.isActive ? "".concat(durationActive, "ms") : "".concat(durationDefault, "ms");
  }, function (p) {
    return p.isActive ? backgroundActive : backgroundDefault;
  }, function (p) {
    return p.isActive ? borderRadiusActive : borderRadiusDefault;
  }, function (p) {
    return p.isActive ? scaleActive : scaleDefault;
  }, function (p) {
    return p.isActive ? opacityActive : opacityDefault;
  });
};